var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 50,
    viewBox: "0 0 145 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 27.668C26.4465 27.668 27.6182 28.9251 27.6183 30.4749V40.1931C27.6181 41.7433 26.4459 43 25 43C23.5536 43 22.3819 41.7428 22.3817 40.1931V30.4749C22.3818 28.9246 23.554 27.6681 25 27.668ZM25.0401 7.00016C25.8325 6.99197 26.5597 7.29508 27.1202 7.80214C28.0233 8.61885 29.1591 9.082 30.3407 9.082H30.4102V9.97625H30.5892V9.90594C30.5892 9.50142 30.8381 9.17335 31.1447 9.17318C31.1882 9.17318 31.224 9.22018 31.224 9.27755V9.48408C31.224 9.54145 31.2597 9.58845 31.3032 9.58845H34.2871C34.3306 9.58838 34.3663 9.5414 34.3663 9.48408V9.48299C34.3664 9.42586 34.4011 9.37991 34.4444 9.37972H34.9219C34.9652 9.3799 34.9999 9.42585 35 9.48299V11.4011C34.9999 11.4583 34.9652 11.5042 34.9219 11.5044H34.4444C34.4011 11.5042 34.3664 11.4583 34.3663 11.4011C34.3663 11.3438 34.3306 11.2968 34.2871 11.2968H31.3032C31.2597 11.2968 31.224 11.3438 31.224 11.4011V11.6077C31.224 11.665 31.1882 11.712 31.1447 11.712C30.8381 11.7119 30.5892 11.3838 30.5892 10.9793V10.9101H30.4102V11.7065H30.3613C29.1781 11.7065 28.0365 12.1657 27.1376 12.9908C26.9946 13.122 26.8398 13.2386 26.6764 13.3412L27.0888 23.2594L27.3394 13.9191C27.3484 13.5955 27.611 13.338 27.9308 13.338V13.3369C30.558 13.3369 32.6359 15.7219 32.4555 18.531L31.6547 30.9858C31.5161 33.1379 29.9178 34.8303 27.9395 34.9825V30.4738C27.9394 28.7105 26.5857 27.28 24.9338 27.3121C23.3406 27.3433 22.0367 28.7932 22.0367 30.5013V34.9825C20.059 34.8271 18.4631 33.1317 18.3279 30.9792L17.5445 18.5244C17.3683 15.7183 19.4448 13.338 22.0692 13.338C22.4656 13.338 22.7926 13.6534 22.8114 14.0542L23.2433 23.2594L23.4657 13.4225C23.2495 13.302 23.0459 13.1592 22.8624 12.9908C21.9635 12.1657 20.8219 11.7065 19.6387 11.7065H19.5898V10.9101H19.4108V10.9793C19.4108 11.3838 19.1619 11.7119 18.8553 11.712C18.8118 11.712 18.776 11.665 18.776 11.6077V11.4011C18.776 11.3438 18.7403 11.2968 18.6968 11.2968H15.7129C15.6694 11.2968 15.6337 11.3438 15.6337 11.4011C15.6336 11.4583 15.5989 11.5042 15.5556 11.5044H15.0792C15.0358 11.5044 15.0001 11.4584 15 11.4011V9.48299C15.0001 9.42574 15.0358 9.37972 15.0792 9.37972H15.5556C15.599 9.37972 15.6347 9.42574 15.6348 9.48299L15.6337 9.48408C15.6337 9.54141 15.6694 9.58838 15.7129 9.58845H18.6968C18.7403 9.58845 18.776 9.54145 18.776 9.48408V9.27755C18.776 9.22018 18.8118 9.17318 18.8553 9.17318C19.1619 9.17335 19.4108 9.50143 19.4108 9.90594V9.97625H19.5898V9.0809H19.6593C20.841 9.0809 21.9766 8.61787 22.8798 7.80104C23.4403 7.29449 24.1675 6.99197 24.9599 7.00016C24.9735 7.00018 24.9868 7.00126 25 7.00126C25.0137 7.00076 25.0269 7.00018 25.0401 7.00016ZM25 8.21631C23.8551 8.21634 22.9276 9.2106 22.9275 10.4377C22.9275 11.6648 23.855 12.6601 25 12.6601C26.145 12.6601 27.0736 11.6649 27.0736 10.4377C27.0735 9.21058 26.1449 8.21631 25 8.21631ZM24.5931 8.58983C25.5453 8.34899 26.4991 8.98106 26.7242 10.0015C26.949 11.0224 26.3594 12.0457 25.4069 12.2866C24.4546 12.5274 23.5008 11.8954 23.2758 10.8749C23.051 9.85407 23.6406 8.83077 24.5931 8.58983Z",
    fill: "#ECECEC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    width: 66,
    height: 6,
    rx: 3,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 11,
    width: 31,
    height: 6,
    rx: 3,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 22,
    width: 62,
    height: 6,
    rx: 3,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 33,
    width: 90,
    height: 6,
    rx: 3,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 44,
    width: 46,
    height: 6,
    rx: 3,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleIcon);
export default __webpack_public_path__ + "static/media/vehicle-icon.5c7ad13e4c72c2688d48de5e9071a40d.svg";
export { ForwardRef as ReactComponent };